import React, { useState, useEffect, useRef } from 'react';
import { config } from 'utils/config';
import { callApi, showSweetAlert } from 'utils/utils';
import FieldButton from 'components/Controls/FieldButton/FieldButton.jsx';
import { Card, CardBody } from 'reactstrap';

const DMINDScreen = () => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    loadDMIND();
  }, []);

  const loadDMIND = async () => {
    setIsLoading(true);
    const redirectUrl = 'https://d-mind.deacerousa.ai/';
    window.location.href = redirectUrl;
  }

  return (
    <div className="d-flex justify-content-center align-items-center h-100">
      {!isLoading && (
        <Card>
          <CardBody className="text-center">
            <h3>Please wait while we launch D-MIND...</h3>
            <p>If you are not redirected automatically, click the button below.</p>
            <FieldButton
              label="Launch D-MIND"
              onClick={() => loadDMIND()}
            />
          </CardBody>
        </Card>
      )}
    </div>
  );
};

export default DMINDScreen;